import { getAuthHeaders, tempMeeApi } from '~/services/api';
import type {
  IUpdateOfficeInfoApiPayload,
  TUpdateOfficeInfoApiResponse,
} from '../types/UpdateOffice.api';

export const updateOfficeInfo = async (
  payload: IUpdateOfficeInfoApiPayload,
): Promise<TUpdateOfficeInfoApiResponse> => {
  const headers = await getAuthHeaders();
  const { data } = await tempMeeApi.patch<TUpdateOfficeInfoApiResponse>(
    '/users',
    payload,
    { headers },
  );
  return data;
};
